import moment from "../../moment";

export const checkIsFromTodayUntilOneMonth = (selectedDate) => {
  const now = new Date();
  const nowHour = now.getHours();

  // 当日(当日は選択可能なため、-1日)
  const start = truncateTime(moment(now).subtract(1, "d"));

  // 1ヶ月後(10:00以降の場合、1ヶ月後の同日は選択可能なので、＋1日)
  let limit;
  if (nowHour > 9) {
    limit = truncateTime(moment(now).add(1, "M").add(1, "d"));
  } else {
    limit = truncateTime(moment(now).add(1, "M"));
  }

  // 日付選択で指定されている日付
  const selected = truncateTime(moment(new Date(selectedDate)));

  console.log("selected :>> ", selected);
  console.log("limit :>> ", limit);
  console.log("start :>> ", start);

  // (start < selected < limit) を満たせばtrue
  return selected.isBefore(limit) && selected.isAfter(start);
};

// 比較用に時間は切り捨て
const truncateTime = (dateString) => {
  const date = new Date(dateString);
  const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  return moment(newDate);
};
